module.exports = __webpack_public_path__ + "static/reviews-1.a4767a36.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/reviews-1.svg
// module id = 1100
// module chunks = 200084577921036